// prime components
import { OverlayPanel as PrOverlayPanel } from 'primereact/overlaypanel'

// Styles
import classes from './styles.module.scss'

// Types
import type { OverlayPanelProps as PrOverlayPanelProps } from 'primereact/overlaypanel'
import type { colorsEnum, sizeEnums } from '@centria-ui/commons/enums'
import type { FC, LegacyRef } from 'react'

export interface OverlayPanelProps extends PrOverlayPanelProps {
  size?: keyof typeof sizeEnums
  color?: keyof typeof colorsEnum
  panelRef: LegacyRef<PrOverlayPanel>
}

export const OverlayPanel: FC<OverlayPanelProps> = ({
  children,
  panelRef,
  size = 'full',
  className = '',
  color = 'white',
  showCloseIcon = true,
  ...props
}) => {
  const append = () => {
    if (typeof document !== 'undefined') return document.body
    else return 'self'
  }

  return (
    <PrOverlayPanel
      {...props}
      ref={panelRef}
      appendTo={append()}
      showCloseIcon={showCloseIcon}
      className={`${className} ${classes.overlay} ${
        classes[`overlay_${color}`]
      }  ${classes[`overlay_${size}`]}`}>
      {children}
    </PrOverlayPanel>
  )
}
